import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Mark app as loaded once React renders
const markAppLoaded = () => {
  if (typeof window.__markAppLoaded__ === 'function') {
    window.__markAppLoaded__();
  }
  // Also remove loading content directly as backup
  const loadingContent = document.querySelector('.app-loading-content');
  if (loadingContent) {
    loadingContent.style.display = 'none';
  }
};

const rootElement = document.getElementById("root");

// Clear any loading state HTML before React mounts
const loadingContent = rootElement.querySelector('.app-loading-content');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App onMount={markAppLoaded} />
    </ErrorBoundary>
  </React.StrictMode>
);

// Mark as loaded after render completes
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    markAppLoaded();
  });
});
